module.exports = __webpack_public_path__ + "6dc445d6ec5c4366909739abd0be359b.pdf";